
import React from 'react';
import { Menubar } from 'primereact/menubar';
import { InputText } from 'primereact/inputtext';
import { Badge } from 'primereact/badge';
//import { Avatar } from 'primereact/avatar';  
import { Button } from 'primereact/button';


import { ApiCallGet } from '../../../ApiCall/ApiCall';

export default function TestDashMenu( { reload , counters }) {


    function closeSessions() {
        ApiCallGet("/dashclose")
        .then( (response) => {
            console.log( response );
            //reload();
        })
        .catch((err)=> {

            console.log( "Nos llego un error =====>>>")

            console.log( err ) // Se detecto un error en la consulta

        })
    }

    const itemRenderer = (item) => (
        <a className="flex align-items-center p-menuitem-link" style={{color:'black'}}>
            <span className={item.icon} />
            <span className="mx-2">{item.label}</span>
            {item.badge && <Badge className="ml-auto" value={item.badge} />}
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
    );
    const items = [
        {
            label: 'Home',
            icon: 'pi pi-home'
        },
        {
            label: 'Features',
            icon: 'pi pi-star'
        },
        {
            label: 'Projects',
            icon: 'pi pi-search',
            items: [
/*
                {
                    label: 'Core',
                    icon: 'pi pi-bolt',
                    shortcut: '⌘+S',
                    template: itemRenderer
                },
                {
                    label: 'Blocks',
                    icon: 'pi pi-server',
                    shortcut: '⌘+B',
                    template: itemRenderer
                },
                {
                    label: 'UI Kit',
                    icon: 'pi pi-pencil',
                    shortcut: '⌘+U',
                    template: itemRenderer
                },
                {
                    separator: true
                },
*/
                {
                    label: 'Procesos',
                    icon: 'pi pi-palette',
                    items: [
                        {
                            label: 'Cerrar sesiones',
                            icon: 'pi pi-palette',
                            badge: 2,
                            command : () => closeSessions(),
                            template: itemRenderer
                        },
                        {
                            label: 'Visualizar sesiones',
                            icon: 'pi pi-palette',
                            badge: 3,
                            command : () => console.log( "Visualizar sesiones") ,
                            template: itemRenderer
                        }
                    ]
                }
            ]
        },
        {
            label: 'Abogados',
            icon: 'pi pi-envelope',
            badge: counters?.lawyers,
            template: itemRenderer
        },
                {
            label: 'Clientes',
            icon: 'pi pi-envelope',
            badge: counters?.clientes,
            template: itemRenderer
        },


    ];

    const start = <img alt="logo" src="https://primefaces.org/cdn/primereact/images/logo.png" height="40" className="mr-2"></img>;
    const end = (
        <div className="flex align-items-center gap-2">
            <Button label="Recargar" style={{borderRadius:'10px'}} onClick={()=> reload()}/>
            <InputText placeholder="Especialidad" type="text" className="w-8rem sm:w-auto" />
            {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" /> */}
        </div>
    );

    return (
        <div className="card">
            <Menubar model={items} start={start} end={end} />
        </div>
    )
}
        